jQuery(document).ready(function () {
  // jQuery('.sort-select select').change(function () {
  //   var sort = jQuery(this).val();
  //   var col =  jQuery('.ajax-product-btn.active').attr('data-col');
  //   var ajaxURL = col+sort;
  //   jQuery('.collection').addClass('loading');
  //   jQuery.ajax({
		// 	url: ajaxURL,
		// 	type: 'GET',
		// 	dataType: 'html',
		// 	success: function (responseHTML) {
  //       var content = jQuery(responseHTML).find('#ProductGridContainer').html();
  //       jQuery('#ProductGridContainer').html(content);
		// 	},
		// 	complete: function () {}
		//   });
  // });
    jQuery('.sort-select input').click(function () {
      var $parent = jQuery(this).parent();
      var $ul = $parent.find("ul"); 
      $parent.toggleClass('active');
     
      $ul.fadeToggle(function() {
      if ($parent.hasClass('active')) {
        $ul.addClass('color')
       } else {
        $ul.removeClass('color')
       }
     });
        if (!$parent.hasClass('active')) {
        $ul.removeClass('color')
       };
     })
  jQuery('.sort-select ul li a').click(function () {
    var $parent = jQuery(this).parents(".sort-select");
    var $ul = $parent.find("ul"); 
    var text = jQuery(this).text();
    jQuery(this).parents('ul').siblings("input").val(text);
    jQuery(this).parent().addClass("active").siblings().removeClass('active');
    jQuery(this).parents('ul').fadeOut().parent().removeClass('active');

    var sort = jQuery(this).attr('data-value');
    var col =  jQuery('.ajax-product-btn.active').attr('data-col');
    var ajaxURL = col+sort;
    jQuery('.collection').addClass('loading');
    
  if (!$parent.hasClass('active')) {
        $ul.removeClass('color')
       };
    
    jQuery.ajax({
			url: ajaxURL,
			type: 'GET',
			dataType: 'html',
			success: function (responseHTML) {
        var content = jQuery(responseHTML).find('#ProductGridContainer').html();
        jQuery('#ProductGridContainer').html(content);
			},
			complete: function () {}
		  });
  })
  
  jQuery('.ajax-product-btn').click(function () {
    console.log(jQuery('.a-link.ajax-product-btn'));
    
    if(!jQuery(this).hasClass('active')){
  
      jQuery('.ajax-product-btn').removeClass('active');
      jQuery(this).addClass('active');
  
      var col = jQuery(this).attr('data-col');
      var sort = jQuery('.sort-select ul li.active a').attr('data-value');
      var ajaxURL = col+sort;
      jQuery('.collection').addClass('loading');
        jQuery(".loading-overlay ").addClass('snippet');
  jQuery(".loading-overlay ").attr("data-title", "dot-pulse");
  jQuery(".loading-overlay ").append(`
    <div class="stage">
        <div class="dot-pulse">
        </div>
    </div>
 `);

       const snippets = document.querySelectorAll('.snippet');

for (let i = 0; i < snippets.length; i++) {
  snippets[i].addEventListener('mouseleave', clearTooltip);
  snippets[i].addEventListener('blur', clearTooltip);
}

function showTooltip(el, msg) {
  el.setAttribute('class', 'snippet tooltip');
  el.setAttribute('aria-label', msg);
}

function clearTooltip(e) {
  e.currentTarget.setAttribute('class', 'snippet');
  e.currentTarget.removeAttribute('aria-label');
}

const clipboardSnippets = new ClipboardJS('.snippet', {
  text: trigger => trigger.getAttribute('data-title')
});

clipboardSnippets.on('success', e => {
  e.clearSelection();
  showTooltip(e.trigger, 'Copied!');
});

clipboardSnippets.on('error', e => {
  showTooltip(e.trigger, 'Copy failed!');
});
      jQuery.ajax({
        url: ajaxURL,
        type: 'GET',
        dataType: 'html',
        success: function (responseHTML) {
          var content = jQuery(responseHTML).find('#ProductGridContainer').html();
          jQuery('#ProductGridContainer').html(content);

        },
        complete: function () {}
       });
    }  else {
        jQuery(".a-link.ajax-product-btn").addClass('active');
        jQuery(this).removeClass('active');
        var defaultURL = window.location.origin + window.location.pathname;; 
        jQuery('.collection').addClass('loading');
        jQuery.ajax({
            url: defaultURL,
            type: 'GET',
            dataType: 'html',
            success: function (responseHTML) {
                var content = jQuery(responseHTML).find('#ProductGridContainer').html();
                jQuery('#ProductGridContainer').html(content);
            },
            complete: function () {
                jQuery('.collection').removeClass('loading');
            }
        });
    }
    
  });
});
